import { Container, Row } from "reactstrap";
import { TooltipTitle, UIKits } from "../../../constants";
import BasicTooltip from "./BasicTooltip";
import ColoredTooltip from "./ColoredTooltip";
import FilledTooltip from "./FilledTooltip";
import HtmlTooltip from "./HtmlTooltip";
import TooltipDirection from "./TooltipDirection";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";

const TooltipContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={TooltipTitle} parent={UIKits} />
      <Container fluid>
        <Row>
          <BasicTooltip />
          <ColoredTooltip />
          <TooltipDirection />
          <HtmlTooltip />
          <FilledTooltip />
        </Row>
      </Container>
    </>
  );
};
export default TooltipContainer;
